<script setup lang="ts">
import { AuthLayoutTemplate } from '@cplug/design-system/components'
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { BaseFormModal } from '@cplug/frontend-core/components'
import BrandLogo from '~/components/BrandLogo.vue'
import { useTranslation } from '~/domain/shared/authentication/components/organisms/HeadlineContainer.i18n'
import headlineBgImage from '~/domain/shared/authentication/components/atoms/headline-bg.png'
import loginCampaignBanner from '~/domain/shared/authentication/components/atoms/login-campaign-banner.jpg'

const loginCampaignUrl = 'https://www.cplug.com.br/?utm_medium=email&utm_source=ActiveCampaign&utm_campaign=banners&utm_content=banner_erp_cplug'

const { t } = useTranslation()
const route = useRoute()

const isLoginPage = computed(() => route.path === '/login')
const headlineBackgroundImageUrl = computed(() =>
  `url(${isLoginPage.value ? loginCampaignBanner : headlineBgImage})`
)
</script>

<template>
  <div
    class="relative"
    :class="{ '[&_.headline-typography]:hidden': isLoginPage }"
  >
    <AuthLayoutTemplate
      show-logo
      :card-class="['flex-1 flex flex-col']"
      :headline-background-image="headlineBackgroundImageUrl"
      :subtitle="isLoginPage ? undefined : t('Subheadline')"
      :headline="isLoginPage ? undefined : t('Headline')"
    >
      <template #logo>
        <BrandLogo size="160px" />
      </template>

      <slot />
    </AuthLayoutTemplate>

    <a
      v-if="isLoginPage"
      :href="loginCampaignUrl"
      target="_blank"
      rel="noopener noreferrer"
      :aria-label="t('CampaignBannerLabel')"
      data-testid="login-campaign-banner"
      class="max-lg:hidden no-underline lg:absolute lg:top-0 lg:left-0 lg:z-20 lg:flex lg:h-full lg:w-1/2 lg:items-end lg:justify-center lg:px-[8%] lg:pb-[6.5%]"
    >
      <span class="flex w-full flex-col items-center text-center">
        <span class="flex flex-col items-center text-[3vw] leading-[1.15] font-bold tracking-[-0.02em] whitespace-nowrap text-white">
          <span>{{ t('CampaignBannerLine1') }}</span>
          <span>{{ t('CampaignBannerLine2') }}</span>
        </span>
        <span class="mt-[0.2em] text-[3.4vw] leading-none font-bold tracking-[-0.02em] whitespace-nowrap text-[#0dc1ef]">
          {{ t('CampaignBannerAccent') }}
        </span>
        <BrandLogo
          class="mx-auto mt-[0.85rem] self-center justify-center! [&_.logo-text-on-color]:fill-white! [&_.st0]:fill-[#0dc1ef]!"
          size="9vw"
        />
      </span>
    </a>

    <BaseFormModal />
  </div>
</template>
